import { AppRouteProps } from "@bsm/component/dist/containers/AppRoutes";
import { TeacherCreateRoutes } from "./create/TeacherCreateRoutes";

export const TeacherListViewsRoutes: Array<AppRouteProps> = [
    ...TeacherCreateRoutes
]